import Header from "./classes/header";

const globalMenuInit = function () {
    // start search buttons and input fields
    const navBarSearchBtn = document.getElementById("mainSearchToggle") as HTMLButtonElement;
    const navBarSearchBtnScrolled = document.getElementById("mainSearchToggleScrolled") as HTMLButtonElement;
    const homepageBtn = document.getElementById("mainsite-search-homepage-btn") as HTMLButtonElement;
    const homepageInput = document.getElementById("mainsite-search-homepage-input") as HTMLInputElement;

    navBarSearchBtn?.addEventListener("click", () => {
        window.location.href = "/search";
    });

    navBarSearchBtnScrolled?.addEventListener("click", () => {
        window.location.href = "/search";
    });

    homepageBtn?.addEventListener("click", () => {
        const query = homepageInput?.value ? `?q=${homepageInput.value}` : '';
        window.location.href = `/search${query}`;
    });

    homepageInput?.addEventListener("keyup", event => {
        if (event.key === 'Enter') {
            window.location.href = `/search?q=${homepageInput.value}`;
        }
    });
    // end search buttons and input fields

    // put var somewhere?
    let header = new Header();

}

document.addEventListener("DOMContentLoaded", function() {
    // menu requires dom to be loaded
    globalMenuInit();
});
